import i18n from "i18next";

const activeLocale = (): string | undefined => i18n.language || undefined;

const makeLazyFormatter = (
  options: Intl.DateTimeFormatOptions,
): Intl.DateTimeFormat => (({
  format: (value: Date | number) =>
    new Intl.DateTimeFormat(activeLocale(), options).format(value),

  formatToParts: (value?: Date | number) =>
    new Intl.DateTimeFormat(activeLocale(), options).formatToParts(value),

  formatRange: (start: Date | number, end: Date | number) =>
    new Intl.DateTimeFormat(activeLocale(), options).formatRange(start, end),

  formatRangeToParts: (start: Date | number, end: Date | number) =>
    new Intl.DateTimeFormat(activeLocale(), options).formatRangeToParts(
      start,
      end,
    ),

  resolvedOptions: () =>
    new Intl.DateTimeFormat(activeLocale(), options).resolvedOptions()
}) as Intl.DateTimeFormat);

const dateFormatter = makeLazyFormatter({
  year: "numeric",
  month: "short",
  day: "numeric",
});

export const dateTimeFormatter = makeLazyFormatter({
  year: "numeric",
  month: "short",
  day: "numeric",
  hour: "numeric",
  minute: "numeric",
});

export const dateTimeFormatterUtc = makeLazyFormatter({
  year: "numeric",
  month: "short",
  day: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  hour12: false,
  timeZone: "UTC",
});

export default dateFormatter;
